import Swiper, { EffectCreative } from "swiper";
import Accordion from "./Accordion";

class AccordionSlider {
    constructor(element, eventType) {
        if (!(element instanceof HTMLElement)) {
            throw new TypeError('Invalid element');
        }

        this.eventType = eventType || 'mouseover';

        this.section = element;
        this.swiperElement = this.section.querySelector('.swiper');
        this.accordionElement = this.section.querySelector('.accordion');

        this.initSwiper();
        this.initAccordion();
    }

    initSwiper() {
        this.swiper = new Swiper(this.swiperElement, {
            modules: [EffectCreative],
            effect: 'creative',
            creativeEffect: {
                prev: {
                    translate: [20, 57, -20]
                },
                next: {
                    translate: [-20, 30, -10]
                }
            },
            allowTouchMove: false,
            loop: true,
        });

        // console.log(this.swiper.el.querySelectorAll('.slider__picture > img'));
    }

    initAccordion() {
        this.accordion = new Accordion(this.accordionElement, this.eventType);
        this.accordionElement.addEventListener('accordion:changed', () => {
            this.swiper.slideToLoop([...this.accordion.items].indexOf(this.accordion.active));
        });
    }
}

export default AccordionSlider;
